angular.module('dpw.components').component('dpwFreeTrialNotification', {
    templateUrl: 'dpw-free-trial-notification.component.html',
    controllerAs: 'ctrl',
    bindings: {},
    controller: ['$scope', '$q', 'dpwStorage', 'api', 'user', 'dpwUserRoleService', 'helpers', 'popup', 'organizationService',
        function ($scope, $q, dpwStorage, api, user, dpwUserRoleService, helpers, popup, organizationService) {
            var self = this;
            var notShowIn24HoursKey = '';

            self.visible = false;
            self.doNotShow = false;
            self.days = 30;

            $scope.$on('$routeChangeSuccess', function () {
                if (helpers.isAppListPage()) {
                    $q.all([
                        user.fetch(),
                        organizationService.getOrganization()
                    ]).then(function (results) {
                        var userObj = user.getUser();
                        var org = results[1];
                        notShowIn24HoursKey = 'NotShowFreeTrialNotificationIn24Hours' + userObj.extensionId;
                        var isTrialDevAdminAccount =
                            userObj.role === dpwUserRoleService.UserRole.Administrator
                            && organizationService.isDeveloper(org)
                            && userObj.isDevAccount
                            && userObj.isTrial;

                        self.visible = isTrialDevAdminAccount && !isLessThan24Hours();
                        var showCancelTrial = isTrialDevAdminAccount && helpers.getSearchParams().action === 'cancelTrial';

                        if (self.visible || showCancelTrial) {
                            api.call(api.devTrialUser.expirationInfo(), function (res) {
                                self.days = res.daysLeft === 0 ? 1 : res.daysLeft;
                                if (showCancelTrial) {
                                    self.cancelTrial();
                                }
                            }, function () {
                                self.visible = false;
                            });
                        }
                    });
                } else {
                    self.visible = false;
                }
            });

            self.close = function () {
                self.visible = false;
                dpwStorage.setItem(notShowIn24HoursKey, new Date().getTime());
            };

            self.cancelTrial = function () {
                var newScope = $scope.$new();
                newScope.onClose = function () {
                    newScope.$destroy();
                };
                newScope.days = self.days;
                popup({
                    scope: newScope,
                    directiveName: 'dpw-cancel-trial',
                    showHeader: false,
                    extraClass: 'popup-auto-width console-ui my-account popup-absolute free-trial-popup-container'
                });
            };

            self.upgrade = function () {
                var newScope = $scope.$new();
                newScope.onClose = function () {
                    newScope.$destroy();
                };
                newScope.days = self.days;
                popup({
                    scope: newScope,
                    directiveName: 'dpw-upgrade-trial',
                    showHeader: false,
                    extraClass: 'popup-auto-width console-ui my-account popup-absolute free-trial-popup-container'
                });
            };


            function isLessThan24Hours() {
                var preTime = parseInt(dpwStorage.getItem(notShowIn24HoursKey), 10);
                return helpers.isLessThan24Hours(preTime);
            }
        }]
});
